import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { numToPrice, toast } from '../../utils/functions';
import { isCellPhone, isNotValidName } from '../../utils/validator';

export default function Input({
    children,
    col = 6,
    label,
    placeholder,
    type = 'text',
    mode = 'text',
    isLTR = false,
    hasIcon = false,
    onChange,
    value,
    required,
    focus,
    name = '',
    minLength ,
    ...attributes
}) {
    const input = useRef(null)
    const [dataValue, setDataValue] = useState('');
    const { t } = useTranslation();
    const [validationError,setValidationError] = useState({
        // fname:'',
        // lname: '',
        // nationalId :''
    })
    const replacer = (key, value)=> {
        if(value?.value?.toString().includes('.')){
            return {value : '',required,label}
        }else if(value?.value?.toString().length < 10 && name ==='nationalId'){
            return {value : '',required,label}
        }else if(value?.value?.toString().length < 11 && type ==='tel' && !isCellPhone(value?.value)){
            return {value : '',required,label}
        }else if(value?.value?.toString().length < 4 && type === 'price'){
            return {value : '',required,label}
        }else if(minLength && value?.value?.toString().length < minLength){
            return {value : '',required,label}
        } else
            return value;
    }
    const dataProps = useMemo(() => JSON.stringify({value, required, label},replacer), [label, required, value]);

    useEffect(() => {
        if(type === 'price'&& value?.toString() !== '0' && value?.toString().length < 4) {
            toast(`${label} معتبر نمیباشد.`,'error')
            return
        }
        if(value?.toString().includes('.')){
            toast(`${label} معتبر نمیباشد.`,'error')
            return
        } 
        // if(value?.toString().length > 0 && value?.toString().length < 10 && name ==='nationalId'){
        //     toast(`${label} معتبر نمیباشد.`,'error')
        //     return
        // } 
        if(minLength && value?.toString().length > 0 && value?.toString().length < minLength){
            toast(`${label} معتبر نمیباشد.`,'error')
            return
        } 
        setDataValue(value ?? '');
    }, [value]);

    function changeText(value) {
        if(type === 'price') setDataValue(value.replace(/[^\d]+|^0+(?!$)/g, ''));////check if the price is valid 
        if(name ==='fname' || name === 'lname') {
            // const englishRegex = /^(?=.*[a-z]|(?=.*[A-Z])|(?=.*[0-9])).*$/;
            if(isNotValidName(value)){
                setValidationError(prevState=>({
                    ...prevState,
                    [name] : `${name === 'fname' ? 'نام' :'نام خانوادگی'} را به صورت فارسی و بدون عدد وارد نمایید`
                }))
            }else {
                setValidationError(prevState=>({
                    ...prevState,
                    [name] : ''
                }))
            }
            setDataValue(value);
        }
        if(name ==='nationalId'){
            if(value?.toString().length > 0 && value?.toString().length < 10){
                setValidationError(prevState=>({
                    ...prevState,
                    [name] : `${label} معتبر نمیباشد`
                }))
            }else {
                setValidationError(prevState=>({
                    ...prevState,
                    [name] : ''
                }))
            }
            setDataValue(value);
        }
        if(name === 'sheba'){
            if(value?.toString().length > 0 && value?.toString().length < 24){
                setValidationError(prevState=>({
                    ...prevState,
                    [name] : `${label} معتبر نمیباشد`
                }))
            }else {
                setValidationError(prevState=>({
                    ...prevState,
                    [name] : ''
                }))
            }
            setDataValue(value);
        } 
        if(type === 'tel'){
            !isCellPhone(value) ?
            setValidationError(prevState=>({
                ...prevState,
                [name] : `${label} معتبر نمیباشد`
            }))
            :
            setValidationError(prevState=>({
                ...prevState,
                [name] : ''
            }))
            setDataValue(value);
        }
        else setDataValue(value);
    }
    function setValue() {
        onChange(dataValue);
    }
    useEffect(()=>{
        focus && input.current.focus()
    },[focus])

    return (
        <div
            className={`col-${col}`}
            // data-props={dataProps}
            data-props={t(dataProps)}
        >
            {
                label &&
                <div 
                    className={`mb5 mt10 `}
                    // className={`mb5 mt20 input-label ${(focus || dataValue !== '') && 'focus'}`}
                >
                    <label>
                        {
                            required &&
                            <span className='required-icon'>* </span>
                        }
                        { label }
                    </label>
                </div>
            }
            <div 
                className={`input-parent ${isLTR ? '' : 'rtl'} ${hasIcon ? 'withIcon' : ''}`}
                // onClick={()=>{
                //     setFocus(true)
                //     input.current.focus()
                // }}
            >
                <input
                    {...attributes}
                    type={type}
                    inputMode={mode}
                    value={type === 'price'? numToPrice(dataValue):dataValue}
                    // placeholder={placeholder || label}
                    onChange={e => changeText(e.target.value)}
                    onBlur={setValue}
                    required={required}
                    // onBlur={()=> {
                    //     setValue()
                    //     dataValue === '' && setFocus(false)
                    // }}
                    ref={input}
                />
                {children}
            </div>
            {validationError[name] && <small className='feild-validation'>{validationError[name]}</small>}
        </div>
    );

}
